var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-result',{attrs:{"icon":"success","title":"正在跳转中..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }